import { render } from "./MyDeliveries.vue?vue&type=template&id=c8a450d2"
import script from "./MyDeliveries.vue?vue&type=script&lang=js"
export * from "./MyDeliveries.vue?vue&type=script&lang=js"
script.render = render

export default script